import { Link, useParams } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { cn } from '../../lib/utils'

/**
 * Switches between the expense list and the expense statement. Each view is
 * its own route, so the tab is a link: the URL says which view is open.
 */
export function ExpensesViewTabs({ active }: { active: 'list' | 'statement' }) {
  const { org } = useParams({ strict: false })
  const { t } = useTranslation('expenses')
  const tab = (key: 'list' | 'statement', to: '/$org/expenses' | '/$org/expenses/statement', label: string) => (
    <Link
      to={to}
      params={{ org: org || 'demo' }}
      role="tab"
      aria-selected={active === key}
      data-testid={`expenses-tab-${key}`}
      className={cn(
        'inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all',
        active === key ? 'bg-background text-foreground shadow-sm' : 'hover:text-foreground',
      )}
    >
      {label}
    </Link>
  )

  return (
    <div role="tablist" className="inline-flex h-10 items-center rounded-md bg-muted p-1 text-muted-foreground">
      {tab('statement', '/$org/expenses/statement', t('tabs.statement'))}
      {tab('list', '/$org/expenses', t('tabs.list'))}
    </div>
  )
}
